import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-go-back',
    standalone: true,
    imports: [CommonModule, MatIconModule],
    templateUrl: './go-back.component.html',
    styleUrls: ['./go-back.component.scss']
})
export class GoBackComponent {
    @Input() public text: string = '';
    @Output() public actionClick: EventEmitter<void> = new EventEmitter<void>();

    public onActionClick(): void {
        this.actionClick.emit();
    }
}
